let throttle = function( fn, ms ) {
  let blocked = false;
  return function() {
    if ( !blocked ) {
      blocked = true;
      fn.apply( this, arguments );
      setTimeout( function() {
        blocked = false;
      }, ms );
    }
  };
};

export default throttle;
